import { render, staticRenderFns } from "./SlideDetailForm.vue?vue&type=template&id=12d3306c&scoped=true"
import script from "./SlideDetailForm.vue?vue&type=script&lang=js"
export * from "./SlideDetailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d3306c",
  null
  
)

export default component.exports